import { baseResponseSchema } from 'services/api/api.types';
import { z } from 'zod/v4';

/* -------------------------------------------------------------------------------------------------
 * request
 * OpenAPI: GetJumioProofOfPaymentUrlRequest
 * POST /ms/jumio/ext/doc-proof/payment
 * "Proof of Payment request - abilitata sulle istanze ESP e PRT"
 * NOTE: requestId / channel / datetime / ipAddress are auto-enriched
 * via headers (enrichRequestData: false), so the payload only carries
 * business fields.
 * -----------------------------------------------------------------------------------------------*/

export const pooDocumentType = z.enum(['CC', 'CCS', 'BS']);

export const postJumioDocProofPaymentPayloadSchema = z.object({
  billCodeId: z.string().min(1),
  documentType: pooDocumentType,
  callbackUrl: z.string().optional(),
  successUrl: z.string().optional(),
  errorUrl: z.string().optional(),
});

type PostJumioDocProofPaymentRequest = z.infer<
  typeof postJumioDocProofPaymentPayloadSchema
>;

/* -------------------------------------------------------------------------------------------------
 * response
 * OpenAPI: GetJumioUrlResponse
 * -----------------------------------------------------------------------------------------------*/

export const jumioDocProofUrlResponseSchema = baseResponseSchema.extend({
  url: z.string().optional(),
  workflowStatus: z.string().optional(),
  sdkToken: z.string().optional(),
  jumioOcrToken: z.string().optional(),
});

type JumioDocProofPaymentIResponse = z.infer<
  typeof jumioDocProofUrlResponseSchema
>;

export type { JumioDocProofPaymentIResponse, PostJumioDocProofPaymentRequest };
